<template>
  <div id="app">

    <loading-bar></loading-bar>
    <router-view></router-view>
    <modal></modal>
    <div class="notifications-list">
      <transition-group name="list" tag="p">
        <span :class="['list-item ','alert', `alert-${notification.type}`] " v-for="notification in notifications" :key="notification.type">
          {{notification.text}}
        </span>
      </transition-group>
    </div>
  </div>
</template>




<script>

import Modal from '@/components/Modal'
import LoadingBar from '@/components/LoadingBar'
import ErrorView from '@/views/shared/ErrorView.vue'
import { mapState } from 'vuex'

//Pour utiliser des fichier js :
//https://stackoverflow.com/questions/59108995/vuejs-webpack-shows-blank-page-after-importing-js-file
//import VueInjectJs from 'vue-inject-js'

export default {
  name: 'app',
  components: {
    Modal,
    ErrorView,
    LoadingBar,

  },
  computed: {
    ...mapState('sessionStore', ['logged']),
    ...mapState('overlayStore', ['notifications']),
  },
  mounted() {
    //do something after mounting vue instance
    console.log('------APP MOUNT-------')
    //this.$store.dispatch('sessionStore/refreshProfileData')
  }
}
</script>





<style>
.bg-nav {
  background-color: #222;
  color: white;
}

.notifications-list {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
.list-item {
  display: block;
  padding: 20px;
  min-width: 200px;
}
.list-enter-active, .list-leave-active {
  transition: all 400ms;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>



// WEBPACK FOOTER //
// App.vue?33928289